var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "form-group form-group--read-only" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { class: `col-sm-${_vm.component.size}` }, [
        !_vm.component.hideLabel
          ? _c("label", [_vm._v(_vm._s(_vm.component.label))])
          : _vm._e(),
        _c(
          "div",
          { staticClass: "lead" },
          [
            _vm.component.prefix
              ? _c("span", { staticClass: "prefix" }, [
                  _vm._v(_vm._s(_vm.component.prefix)),
                ])
              : _vm._e(),
            _c("span", { staticClass: "text" }, [
              _vm._v(_vm._s(_vm.getValue())),
            ]),
            _vm._l(_vm.labels, function (label) {
              return _c("li", { key: label }, [_vm._v(_vm._s(label))])
            }),
            _vm.component.suffix
              ? _c("span", { staticClass: "suffix" }, [
                  _vm._v(_vm._s(_vm.component.suffix)),
                ])
              : _vm._e(),
          ],
          2
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }